import { render } from "./ResetAll.vue?vue&type=template&id=e4ffe2d0"
import script from "./ResetAll.vue?vue&type=script&lang=js"
export * from "./ResetAll.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__